import { render, staticRenderFns } from "./how-to-receive-dividends.vue?vue&type=template&id=2148c5ab"
import script from "./how-to-receive-dividends.vue?vue&type=script&lang=js"
export * from "./how-to-receive-dividends.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./locale/dividend-distribution-en.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fvercel%2Fpath0%2Fpages%2Finvesting%2Fservices%2Fhow-to-receive-dividends.vue&locale=en&external"
if (typeof block0 === 'function') block0(component)
import block1 from "./locale/dividend-distribution-ar.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fvercel%2Fpath0%2Fpages%2Finvesting%2Fservices%2Fhow-to-receive-dividends.vue&locale=ar&external"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PageHero: require('/vercel/path0/components/PageHero.vue').default,PageIntroBlock: require('/vercel/path0/components/PageIntroBlock.vue').default,AppStoreLinks: require('/vercel/path0/components/blocks/AppStoreLinks.vue').default,CImage: require('/vercel/path0/components/ui/c-image.vue').default,FootNote: require('/vercel/path0/components/FootNote.vue').default,RelatedLinks: require('/vercel/path0/components/RelatedLinks.vue').default,FaqsAccordion: require('/vercel/path0/components/datablocks/FaqsAccordion.vue').default})
